import { render, staticRenderFns } from "./RepositoryForm.vue?vue&type=template&id=9198d6ee&scoped=true"
import script from "./RepositoryForm.vue?vue&type=script&lang=js"
export * from "./RepositoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9198d6ee",
  null
  
)

export default component.exports